// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2oj6j","tab":"ProcedureTabs_tab__2mBLb"};